import { createModule } from '../utils/factories';
import { resources } from '@/services/resources';
import crud from '../components/crud';
import indexManager from '../components/indexManager';

export default createModule({
  path: 'filterSet',
  resourceProfile: resources.filterSet,
  components: [crud, indexManager],
  setup({ components }) {
    return {
      module: {},
      public: {
        ...components.$crud.public,
        ...components.$indexManager.public,
      },
    };
  },
});
